import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Clock, ShieldCheck } from 'lucide-react';
export function CountdownBar() {
  const {
    minutes,
    seconds
  } = useCountdown(20);
  return <div className="sticky top-0 z-50 w-full" data-id="element-19">
      {/* Top info bar */}
      <div className="w-full bg-brand-bg-beige border-b border-brand-bg-cream py-1.5 px-4" data-id="element-20">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-brand-green" data-id="element-21">
          <ShieldCheck size={14} className="flex-shrink-0" data-id="element-22" />
          <span data-id="element-23">Producto 100% digital · Plan aprobado de 21 días</span>
        </div>
      </div>
      {/* Countdown bar */}
      <div className="w-full bg-brand-green text-white py-2 px-4 shadow-md" data-id="element-24">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-25">
          <span className="text-center" data-id="element-26">
            Oferta disponible por tiempo limitado
          </span>
          <div className="flex items-center gap-1.5 bg-white/20 px-3 py-1 rounded-full" data-id="element-27">
            <Clock size={16} className="animate-pulse" data-id="element-28" />
            <span className="font-poppins font-semibold tracking-wider" data-id="element-29">
              {minutes}:{seconds}
            </span>
          </div>
        </div>
      </div>
    </div>;
}